import React, { Component } from "react";
import styles from "./title.module.scss";

function Title({ title }) {
  return <h2 className={styles.cardTitle}>{title}</h2>;
}

export default Title;
